export default "<p>hotel-manage works!</p>\n"